import { Toast as BaseToast } from "@base-ui/react/toast";
import {
  IconCheck,
  IconExclamationCircle,
  IconInfoCircle,
  IconX,
} from "@tabler/icons-react";
import type { ComponentType, ReactNode } from "react";
// @ts-expect-error pure js
import { classnames } from "../../../utils";
import styles from "./Toast.module.css";
import type { ToastData, ToastVariant } from "./useToast";
import Text from "../Text.tsx";
import Title from "../Title.tsx";
import IconButton from "../IconButton.tsx";

const ICONS: Record<ToastVariant, ComponentType<{ size?: number }>> = {
  success: IconCheck,
  error: IconExclamationCircle,
  info: IconInfoCircle,
};

interface ToastProviderProps {
  children: ReactNode;
}

export function ToastProvider({ children }: ToastProviderProps) {
  return (
    <BaseToast.Provider>
      {children}
      <ToastViewport />
    </BaseToast.Provider>
  );
}

function ToastViewport() {
  const { toasts } = BaseToast.useToastManager<ToastData>();
  return (
    <BaseToast.Portal>
      <BaseToast.Viewport className={styles.viewport}>
        {toasts.map((toast) => (
          <ToastItem key={toast.id} toast={toast} />
        ))}
      </BaseToast.Viewport>
    </BaseToast.Portal>
  );
}

function ToastItem({
  toast,
}: {
  toast: BaseToast.Root.ToastObject<ToastData>;
}) {
  const variant = toast.data?.variant ?? "success";
  const Icon = ICONS[variant];
  return (
    <BaseToast.Root
      toast={toast}
      className={classnames(styles.root, styles[variant])}
    >
      <div className={styles.iconWrap}>
        <Icon size={16} />
      </div>
      <div className={styles.content}>
        {toast.title !== undefined && (
          <BaseToast.Title
            render={
              <Title variant="deca" weight="bold">
                {toast.title}
              </Title>
            }
          />
        )}
        {toast.description !== undefined && (
          <BaseToast.Description
            className={styles.description}
            render={<Text as="div">{toast.description}</Text>}
          />
        )}
      </div>
      <BaseToast.Close
        render={
          <IconButton icon={IconX} label="Fermer" variant="plain" size="sm" />
        }
      />
    </BaseToast.Root>
  );
}
